import React from 'react';
import Commerce2Json from '../../Util/Commerce2Json';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import {pStyles} from "../../Util/ThemeUtils";
import FormattedText from "../FormattedText/FormattedText";
import MediaSlider from "../MediaSlider/MediaSlider";
import {Link} from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import {withSnackbar} from "notistack";
import ProductActions from "../Products/ProductActions";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import RatingCategories from "../RatingItem/RatingCategories";
import VariationSelector from "../../core/rewards/VariationSelector";

class PickupMatchBlock extends React.Component {

    render() {
        const {classes} = this.props;
        const cartItem = new Commerce2Json(this.props.product);
        let timezone = cartItem.get('field_json', 'timezone');
        const address = cartItem.getAddress('short');
        const linkTo = `/group/${cartItem.get('stores', 'gid')}/rewards/${cartItem.get('product_id')}`;
        const vote_types = cartItem.product.get('field_json', 'vote_types');
        const dateRange = cartItem.product.getTimeRange('field_date_range', 'ddd MMM Do \'YY hh:mm a', timezone);
        let end_date = cartItem.product.getTimestamp('field_date_range', 'end_value');
        end_date = end_date === 0 || end_date > new Date().getTime() ? false : true; // 0 means it has not even been scheduled yet

        const headerAttrs = {
            title: <Link to={linkTo}>{cartItem.product.get('title')}</Link>,
            subheader: <Grid container flexDirection={'column'}>
                {dateRange ?
                    <Grid item xs={12} component={Typography}
                          variant={'subtitle1'}>{dateRange}
                    </Grid>
                    :
                    <Grid item xs={12} component={Typography}
                          variant={'h6'}>Date & Time TBA
                    </Grid>
                }
                <Grid item xs={12} component={Typography} variant={'subtitle2'}>
                    {cartItem.getPriceRange()} &nbsp;
                    {address &&
                        <a target={"_blank"} className={'address'}
                           href={`https://maps.google.com?q=${encodeURI(cartItem.getAddress('long'))}`}>@ {cartItem.get("field_address", "given_name") || address}</a>}
                </Grid>
            </Grid>
        }

        if (cartItem.get('field_sport', 'url')) {
            headerAttrs.avatar = <img src={cartItem.get('field_sport', 'url')}/>
        }
        headerAttrs.action =
            <ProductActions me={this.props.me} gid={cartItem.get('stores', 'gid')} cartItem={cartItem}
                            vote_types={vote_types}
                            dispatch={this.props.dispatch}/>

        const allMedia = cartItem.getAllMedia();

        let actions = null;
        if (end_date === false) {
            actions = <VariationSelector product={this.props.product} dispatch={this.props.dispatch} />
        } else if (this.props.product.stats) {
            actions = []
            if (this.props.product.stats.clips > 0) {
                actions.push(<Button key={`${linkTo}cliplinks`}  component={Link} to={`${linkTo}/clips`} endIcon={this.props.product.stats.clips}
                                     color={'primary'} variant={"contained"} >View Clips</Button>)
            }
            if (this.props.product.stats.footage > 0) {
                actions.push(<Button key={`${linkTo}footagelink`} color={'primary'} component={Link} to={`${linkTo}/footage`} endIcon={this.props.product.stats.footage} >View Footage</Button>)
            }
        }


        return (
            <Card className={['rBlock', classes.card].join(' ')}>

                <CardHeader className={classes.pickupMatchCard} {...headerAttrs} />

                {allMedia.length > 0 && <MediaSlider linkTo={linkTo} images={allMedia}/>}

                {cartItem.getField('body') &&
                    <CardContent className={classes.content}>
                        <FormattedText {...cartItem.getField('body')} displayField={'auto'}/>
                        {vote_types && <RatingCategories vote_types={vote_types} cartItem={cartItem}
                                                         dispatch={this.props.dispatch}/>}
                    </CardContent>}

                {actions && <CardActions className={classes.actions}>{actions}</CardActions>}

            </Card>
        );
    }
}

PickupMatchBlock.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(pStyles, {withTheme: true})(withSnackbar(PickupMatchBlock));
